import React from 'react';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import styles from './AddressInformations.module.sass';

const AddressInformations = ({ student, onStudentChange }) => {
  return (
    <Card className={styles.card} title="Adresse de l'étudiant" classTitle="title-green">

      <div className={styles.group}>

        <TextInput
          className={styles.field}
          label="Adresse"
          name="address"
          type="text"
          placeholder="Adresse complète"
          value={student?.address || ''}
          onChange={onStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Complément d'adresse"
          name="address_complement"
          type="text"
          placeholder="Ex: Appartement, étage..."
          value={student?.address_complement || ''}
          onChange={onStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Code Postal"
          name="zip_code"
          type="text"
          placeholder="Code postal"
          value={student?.zip_code || ''}
          onChange={onStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Ville"
          name="city"
          type="text"
          placeholder="Ville"
          value={student?.city || ''}
          onChange={onStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Pays"
          name="country"
          type="text"
          placeholder="Pays"
          value={student?.country || ''}
          onChange={onStudentChange}
        />
      </div>
    </Card >
  );
};

export default AddressInformations;
